import { AI_MODEL_OPTIONS, type AiModelKey } from '../utils/aiModels';

interface AiModelSelectProps {
  id: string;
  value: AiModelKey;
  onChange: (value: AiModelKey) => void;
  disabled?: boolean;
}

export function AiModelSelect({ id, value, onChange, disabled }: AiModelSelectProps) {
  return (
    <>
      <label htmlFor={id} className="sr-only">
        AI model
      </label>
      <select
        id={id}
        value={value}
        onChange={(event) => onChange(event.target.value as AiModelKey)}
        disabled={disabled}
        className="h-8 rounded-md border border-gray-300 bg-white px-2 text-sm text-gray-700 shadow-sm transition-colors hover:border-gray-400 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-400"
      >
        {AI_MODEL_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </>
  );
}
